import { render, staticRenderFns } from "./TabHeaderFilter.vue?vue&type=template&id=5d4e3e19&scoped=true"
import script from "./TabHeaderFilter.vue?vue&type=script&lang=js"
export * from "./TabHeaderFilter.vue?vue&type=script&lang=js"
import style0 from "./TabHeaderFilter.vue?vue&type=style&index=0&id=5d4e3e19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e3e19",
  null
  
)

export default component.exports